import * as i0 from '@angular/core';
import * as i1 from './rightclicktrigger.module';
import * as i2 from './rightclicktrigger.directive';
export const RightClickTriggerModuleNgFactory:i0.NgModuleFactory<i1.RightClickTriggerModule> = (null as any);
var _decl0_0:i2.RightClickTriggerDirective = (<any>(null as any));
